import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import {ContentHeaderComponent} from "./components/content-header/content-header.component";
import {BreadcrumbComponent} from "./components/breadcrumb/breadcrumb.component";
import {ContentHeaderDashComponent} from "./components/content-header-dash/content-header-dash.component";
import {DialogComponent} from "./components/dialog/dialog.component";
import {PipesModule} from "../theme/pipes/pipes.module";
import {SearchBarComponent} from "./components/search-bar/search-bar.component";
import {FieldsetComponent} from "./components/fieldset/fieldset.component";
import {LoadModalComponent} from "./components/load-modal/load-modal.component";
import {FormsModule} from "@angular/forms";
import { ModalEmailReportComponent } from './components/modal-email-report/modal-email-report.component';
import { DnaPaginatorComponent } from './components/dna-paginator/dna-paginator.component';
import { DnaSearchSelectComponent } from './components/dna-search-select/dna-search-select.component';
import { DnaAlertComponent } from './components/dna-alert/dna-alert.component';
import { DnaDatepickerComponent } from './components/dna-datepicker/dna-datepicker.component';

@NgModule({
  providers: [provideNgxMask()],
  imports: [
    CommonModule,
    RouterModule,
    NgxMaskDirective,
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatStepperModule,
    PipesModule,
    FormsModule
  ],
  exports: [
    NgxMaskDirective,
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatStepperModule,
    ContentHeaderComponent,
    ContentHeaderDashComponent,
    BreadcrumbComponent,
    DialogComponent,
    PipesModule,
    LoadModalComponent,
    FieldsetComponent,
    SearchBarComponent,
    FormsModule,
    DnaPaginatorComponent,
    DnaSearchSelectComponent,
    DnaAlertComponent,
    DnaDatepickerComponent
  ],
  declarations: [
    ContentHeaderComponent,
    BreadcrumbComponent,
    ContentHeaderDashComponent,
    DialogComponent,
    LoadModalComponent,
    FieldsetComponent,
    SearchBarComponent,
    ModalEmailReportComponent,
    DnaPaginatorComponent,
    DnaSearchSelectComponent,
    DnaAlertComponent,
    DnaDatepickerComponent,
  ]
})
export class SharedModule { }
